import { TYPO } from "styles/Typo";
import { useHorizontalScroll, usePortfolioSimUtil } from "utils/portfolio/sim";
import PortfolioTeaserDiagMainSimDetail from "../../Portfolio/Teaser/Diag/main/SimDetail";
import Image from "next/image";
import PortfolioTeaserSimLineChart from "../../Portfolio/Teaser/Sim/LineChart";
import { useState } from "react";
import { motion } from "framer-motion";
import { useRouter } from "next/router";
import { useHandleImageErrorVer2 } from "utils/useHandleImageError";
import { SkeletonBlock3 } from "components/skeleton";

function MainPortfolioSim({ portId }: { portId: number | null }) {
  const router = useRouter();
  const [activeIndex, setActiveIndex] = useState(0);
  const { getStockLogoSafe, onError } = useHandleImageErrorVer2();
  const {
    yearLogReturn,
    itemInfo,
    similarity,
    averageSimilarity,
    isLoading,
    isError,
  } = usePortfolioSimUtil(Number(portId));

  const reverseSimilarity = similarity !== null ? 100 - similarity : undefined;

  const level = reverseSimilarity
    ? reverseSimilarity > 50
      ? "high"
      : "low"
    : "";

  const iconSize = 24;
  const gap = 6;

  const {
    containerRef,
    scrollerRef,
    isDragging,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    translateX,
    scrollToIndex,
    notiTextVisible,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
  } = useHorizontalScroll(itemInfo, activeIndex, setActiveIndex, iconSize, gap);

  const desc =
    level === "high"
      ? `주가가 불규칙하게 움직여요 \n시장이 나빠져도 대응할 수 있어요`
      : `주가가 비슷하게 움직여요 \n시장이 좋으면 수익을 크게 볼 수 있어요 `;
  if ((!yearLogReturn || isLoading) && !isError)
    return (
      <div className="px-4 pt-[30px]">
        <SkeletonBlock3 width={"100%"} height={300} />
      </div>
    );

  console.log("reverseSimilarity", reverseSimilarity);
  return (
    <div>
      {yearLogReturn && similarity !== null && (
        <>
          <p className={`px-6 pt-[30px] ${TYPO.TYPO5_SB} text-gray90`}>
            주가 흐름
          </p>

          <div className="p-4 flex flex-col gap-[10px]">
            <div className="   bg-1 rounded-[14px] flex flex-col ">
              <div className="flex items-center px-4  py-[10px]">
                <div className="flex flex-col gap-1 grow">
                  <div className="flex gap-[6px] items-center">
                    <p className={`${TYPO.TYPO7_MD} text-gray90`}>
                      {level === "high" ? "분산형" : "집중형"}
                    </p>
                    <p
                      className={`${TYPO.TYPO9_MD} text-gray70 bg-gray20 px-[6px] py-[1px] rounded-[20px]`}
                    >
                      {reverseSimilarity !== null
                        ? `${reverseSimilarity?.toFixed(0)}%`
                        : "-"}
                    </p>
                  </div>
                  <p
                    className={`whitespace-pre-line ${TYPO.TYPO7_1_RG} text-gray70`}
                  >
                    {desc}
                  </p>
                </div>
                {/* <Button
                type="secondary"
                size="sm"
                clickHandler={goHighScorePage}
                text={level === "high" ? "분산도 낮추기" : "분산도 올리기"}
                dataTestId="pf-sim-u"
              /> */}
              </div>
              {/* <div className="px-4 py-1">
              <div className="w-full h-[1px] bg-hairline" />
            </div> */}
              <div className="flex flex-col gap-[3px] px-4 pb-4 pt-2">
                <div className="w-full rounded-[20px] h-[6px] bg-gray20 relative">
                  <div
                    className="bg-blue40 rounded-full w-[6px] h-[6px] absolute top-[50%] translate-y-[-50%] translate-x-[-50%] z-[1]"
                    style={{
                      left: `${reverseSimilarity}%`,
                    }}
                  >
                    <div
                      className="absolute bottom-[-3px] left-[50%]  flex flex-col items-center justify-center w-[32px]  "
                      style={{
                        transform: "translateY(100%) translateX(-50%)",
                      }}
                    >
                      <Icon2 />

                      <div
                        className={`${TYPO.TYPO9_MD} text-gray70 bg-gray20 px-[6px] rounded-[5px]`}
                      >
                        나
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-between items-center">
                  <div className="text-left">
                    <p className={`${TYPO.TYPO10_MD} text-gray50`}>집중</p>
                    <p className={`${TYPO.TYPO10_MD} text-gray50`}>0%</p>
                  </div>
                  <div className="text-right">
                    <p className={`${TYPO.TYPO10_MD} text-gray50`}>분산</p>
                    <p className={`${TYPO.TYPO10_MD} text-gray50`}>100%</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex bg-1 flex-col rounded-[16px] overflow-hidden">
              <div className="w-full z-[2] ">
                <PortfolioTeaserSimLineChart
                  data={yearLogReturn}
                  activeIndex={activeIndex}
                  height={120}
                  theme="white"
                  paddingTop={0}
                  paddingBottom={0}
                />
              </div>

              <div
                className={`bg-1  p-2 border-t border-hairline py-3 h-[62px]`}
              >
                <div
                  className={`relative  overflow-hidden pf-card-clickable h-full`}
                  style={{}}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={(e) => handleMouseUp(e)}
                  ref={containerRef}
                >
                  {notiTextVisible && (
                    <motion.div
                      className="flex items-center absolute top-[50%] translate-y-[-50%] left-[3px] pl-[15px]"
                      animate={{
                        x: [0, 15, 0],
                        y: ["-50%", "-50%", "-50%"],
                      }}
                      transition={{
                        duration: 2,
                        ease: "easeInOut",
                        repeat: Infinity,
                        repeatType: "loop",
                      }}
                    >
                      <Icon />
                      <p
                        className="animate-[shimmer_3s_linear_infinite] font-[500] text-[14px] leading-[19.6px]"
                        style={{
                          background:
                            "linear-gradient(93deg, var(--grey60, #647A90) 0%, var(--grey30, #BDC7D1) 50%, var(--grey-60, #647A90) 100%)",
                          backgroundSize: "200% auto",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        밀어서 비교하기
                      </p>
                    </motion.div>
                  )}
                  <div
                    ref={scrollerRef}
                    id="sim-scroller-icons"
                    className="flex absolute top-[50%] translate-y-[-50%] left-[50%] z-[1] bg-transparent h-full items-center justify-center"
                    style={{
                      transform: `translate3d(${
                        translateX - iconSize / 2
                      }px, -50%, 0)`,
                      transition: isDragging
                        ? "none"
                        : "transform 0.1s ease-in-out",
                      cursor: isDragging ? "grabbing" : "grab",
                      userSelect: "none",
                      gap: gap,
                      touchAction: "none", // 아이콘 영역에서는 모든 터치 동작을 제어
                      willChange: isDragging ? "transform" : "auto", // 성능 최적화
                    }}
                  >
                    {itemInfo?.map((item: any, index: number) => (
                      <div
                        key={index}
                        className="scroller-icon  cursor-pointer h-full flex items-center justify-center"
                        onClick={() => scrollToIndex(index)}
                        style={{
                          width:
                            activeIndex === index ? iconSize * 1.5 : iconSize,
                          height:
                            activeIndex === index ? iconSize * 1.5 : iconSize,
                          // transform:
                          //   activeIndex === index ? "scale(1.5)" : "scale(1)",

                          transition:
                            "width 0.3s ease-in-out, height 0.3s ease-in-out",
                        }}
                        data-testid={`pf-sim-card-icon-${item.ITEM_CD_DL}`}
                      >
                        <Image
                          src={getStockLogoSafe(item.ITEM_CD_DL)}
                          alt={item.ITEM_KR_NM}
                          width={
                            activeIndex === index ? iconSize * 1.5 : iconSize
                          }
                          height={
                            activeIndex === index ? iconSize * 1.5 : iconSize
                          }
                          className="rounded-full shrink-0"
                          draggable={false}
                          style={{
                            width:
                              activeIndex === index ? iconSize * 1.5 : iconSize,
                            height:
                              activeIndex === index ? iconSize * 1.5 : iconSize,
                            objectFit: "cover",
                            filter:
                              activeIndex === index
                                ? "none"
                                : "grayscale(100%)",
                            opacity: activeIndex === index ? 1 : 0.6,
                            transition:
                              "filter 0.3s ease-in-out, opacity 0.3s ease-in-out, width 0.3s ease-in-out, height 0.3s ease-in-out",
                          }}
                          onError={() => onError(item.ITEM_CD_DL)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <mask
      id="mask0_22073_13420"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_22073_13420)">
      <path
        d="M5.21719 8.00001L7.80052 10.6C7.92274 10.7222 7.98663 10.875 7.99219 11.0583C7.99774 11.2417 7.93385 11.4 7.80052 11.5333C7.6783 11.6556 7.52274 11.7167 7.33385 11.7167C7.14497 11.7167 6.98941 11.6556 6.86719 11.5333L3.80052 8.46667C3.73385 8.40001 3.68663 8.32778 3.65885 8.25001C3.63108 8.17223 3.61719 8.0889 3.61719 8.00001C3.61719 7.91112 3.63108 7.82778 3.65885 7.75001C3.68663 7.67223 3.73385 7.60001 3.80052 7.53334L6.86719 4.46667C6.98941 4.34445 7.14219 4.28056 7.32552 4.27501C7.50885 4.26945 7.66719 4.33334 7.80052 4.46667C7.92274 4.5889 7.98385 4.74445 7.98385 4.93334C7.98385 5.12223 7.92274 5.27778 7.80052 5.40001L5.21719 8.00001ZM9.61719 8.00001L12.2005 10.6C12.3227 10.7222 12.3866 10.875 12.3922 11.0583C12.3977 11.2417 12.3339 11.4 12.2005 11.5333C12.0783 11.6556 11.9227 11.7167 11.7339 11.7167C11.545 11.7167 11.3894 11.6556 11.2672 11.5333L8.20052 8.46667C8.13385 8.40001 8.08663 8.32778 8.05885 8.25001C8.03108 8.17223 8.01719 8.0889 8.01719 8.00001C8.01719 7.91112 8.03108 7.82778 8.05885 7.75001C8.08663 7.67223 8.13385 7.60001 8.20052 7.53334L11.2672 4.46667C11.3894 4.34445 11.5422 4.28056 11.7255 4.27501C11.9089 4.26945 12.0672 4.33334 12.2005 4.46667C12.3227 4.5889 12.3839 4.74445 12.3839 4.93334C12.3839 5.12223 12.3227 5.27778 12.2005 5.40001L9.61719 8.00001Z"
        fill="var(--gray40)"
      />
    </g>
  </svg>
);

const Icon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="3"
    viewBox="0 0 9 3"
    fill="none"
  >
    <path d="M8.5 3L0.5 3L4.5 0L8.5 3Z" fill={"var(--gray20)"} />
  </svg>
);
export default MainPortfolioSim;
